import cloneDeep from 'lodash/cloneDeep';
import { useMemo } from 'react';

// useInitialItem returns either the item being updated or a memoized version of the new item with
// its default attributes set. This result should be used to set the initial item of the form.
export default function useInitialItem(item, newItemAttrs) {
  const newItem = useMemo(() => ({ ...newItemAttrs }), []); // eslint-disable-line react-hooks/exhaustive-deps
  return item ? cloneDeep(item) : newItem;
}
